<template>
  <div class="app-login">
    <form class="app-login-form">
      <img class="app-login-logo" src="../assets/img/logo_white.png" alt="Eurocaja Rural"/>
      <h4 class="app-login-title">Portal de Proveedores de Confirming</h4>
      <h4 class="app-login-title app-login-title-second-line">Bienvenido a tu nuevo portal. Configura tu contraseña de acceso</h4>
      <div class="form-group">
        <div class="mensajeConfirmacionReducido" v-if="confirmacion=='OK'">
            <p>check_circle</p>
            <h3>Operación realizada. Ya puede utilizar su nueva contraseña</h3>
          </div>
        <div class="mensajeErrorReducido" v-if="confirmacion=='KO'">
          <p>warning</p>
          <h3>{{mensajeError}}</h3>
        </div>
        <!--<span class="app-firstLogin-information">Si accede al servicio por primera vez, introduzca el código de identificación fiscal del proveedor y la clave que le 
          hemos remitido en la Notificación de pago y pulse 'Entrar'</span>-->
        <input class="inputLoginComponent" type="text" name="documentId" placeholder="NIF *" v-model="cif" required :disabled="tokenValido"/>
        <input class="inputLoginComponent" maxlength="8" required :type="textPass1" name="token" placeholder="Clave *" v-model="token" :disabled="tokenValido"/>
        <span class="material-icons visibility" id="eye1" @click="showPassword" v-if="eye1 && !tokenValido">visibility</span>
        <span class="material-icons visibility" id="eye1" @click="hidePassword" v-if="!eye1 && !tokenValido">visibility_off</span>
        <br>
        <input class="btnPrimary" type="button" value="Entrar" @click="entrar" :disabled="isDisabled" v-if=!tokenValido>

        <div class="form-group second-form-group" v-if="tokenValido && beforeOTP">          
          <h5 class="app-login-title">Cambio de contraseña requerido</h5>
          <input :class = "(submitted && $v.model.newPass.$invalid)?'inputLoginInvalid':'inputLoginComponent'" maxlength="6" @keypress="numericInput" required :type="textPass2" name="password" placeholder="Nueva contraseña *" autocomplete="off" v-model="model.newPass" :disabled="datosOTP"/>
          <span class="material-icons visibility" id="eye2" @click="showPassword" v-if="eye2 && !datosOTP">visibility</span>
          <span class="material-icons visibility" id="eye2" @click="hidePassword" v-if="!eye2 && !datosOTP">visibility_off</span>
          <div class="error" v-if="submitted && !$v.model.newPass.required">Este campo es obligatorio</div>
          <div class="error" v-if="submitted && !$v.model.newPass.minLength">La contraseña debe contener como mínimo 6 caracteres.</div>
          <input :class = "(submitted && $v.model.newPassRep.$invalid)?'inputLoginInvalid':'inputLoginComponent'" maxlength="6" @keypress="numericInput" required :type="textPass3" name="password" placeholder="Repita nueva contraseña *" autocomplete="off" v-model="model.newPassRep" :disabled="datosOTP"/>
          <span class="material-icons visibility" id="eye3" @click="showPassword" v-if="eye3 && !datosOTP">visibility</span>
          <span class="material-icons visibility" id="eye3" @click="hidePassword" v-if="!eye3 && !datosOTP">visibility_off</span>
          <div class="error" v-if="submitted && !$v.model.newPassRep.required">Este campo es obligatorio</div>
          <div class="error" v-if="submitted && !$v.model.newPassRep.minLength">La contraseña debe contener como mínimo 6 caracteres.</div>
          <div class="error" v-if="submitted && !$v.model.newPassRep.sameAsnewPass">El campo debe tener el mismo valor que el campo Nueva contraseña</div>
          <br>
                <div v-if=datosOTP>
                  <OTPComponent :params="params" :datosOTP="datosOTP" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelarOTP"></OTPComponent>
                </div>
          <input class="btnPrimary" type="button" value="Aceptar" @click="changePass" :disabled="isDisabled2" v-if=beforeSubmit>
          <div class="app-login-disclaimer">
            <div class="icon-lock">
              
            </div>
            <p>
                <b>Pautas para elegir una contraseña</b><br>
                    <ul class="circulos">
                      <li>Debe tener 6 caracteres.</li>
                      <li>No deben repetirse contraseñas anteriores.</li>
                      <li>No se permiten números consecutivos (Ej: 123456).</li>
                      <li>No se permiten números repetidos (Ej: 111111).</li>
                    </ul>
            </p>
          </div>
        </div>
        <div class="app-login-disclaimer">
            <div class="icon-lock">
              
            </div>
            <p>
                Recomendaciones de Seguridad:
                <br/>
                <br/>
                Mantén tus claves en secreto y cámbialas regularmente.
                <br/>
                No introduzcas la Clave de Firma para consulta de saldo, movimientos, o sin haber iniciado ninguna operación.
                <br/>
                No olvides pulsar salir al terminar tu sesión.
                <br/>
                Nunca te solicitaremos tus claves personales y confidenciales por teléfono, correo electrónico o fax, ni te pediremos que realices ninguna prueba de operaciones en tu oficina digital.
                <br/>
                <br/>
                Si tienes dudas, llama a nuestro servicio de Atención al cliente 925 26 96 44.
            </p>
          </div>
      </div>
  
    </form>
  </div>
</template>

<script>
import { required, minLength } from "vuelidate/lib/validators";
import ModificarContrasena from '../models/ModificarContrasena';
import OTPComponent from './OTPComponent';  
export default {
  name: "FirstLoginClientComponent",
  data() {
    return {
      cif:null,
      datosOTP: null,
      token:null,
      eye1:true,
      eye2:true,
      eye3:true,
      textPass1 : "password",
      textPass2 : "password",
      textPass3 : "password",
      params:null,
      llamada:null,
        beforeSubmit:true, //este submit es para el otp
        submitted:false, //este es para las validaciones
        mensajeError: null,
        confirmacion:null,
        beforeOTP : true,
      tokenValido:false, //indicador de la validez del token
      model:new ModificarContrasena()
    }
  },
  computed : {
    isDisabled: function() {
        return !this.cif || !this.token;
    },
    isDisabled2: function() {
        return !this.model.newPass || !this.model.newPassRep;
    }
  },
  components: {
      OTPComponent
    },
    validations : {
      model : {
        newPass: {
          required,
          minLength: minLength(6),
        },
        newPassRep: {
          required,
          minLength: minLength(6),
          sameAsnewPass: function() {
            return (this.model.newPass==this.model.newPassRep);
          }
        }
      }
    },
  methods : {
    numericInput(a) {
      if (a.which < 48 || a.which > 57) {
        a.preventDefault();
      }
    },
    showPassword(cmp) {
      var numero = cmp.srcElement.id.substring(3);
      switch(numero) {
        case "1":
          this.eye1= false;
          this.textPass1 = "text";
          break;
        
        case "2":
          this.eye2= false;
          this.textPass2 = "text";
          break;

        case "3":
          this.eye3= false;
          this.textPass3 = "text";
          break;
      }
      
    },
    hidePassword(cmp) {
      var numero = cmp.srcElement.id.substring(3);
      switch(numero) {
        case "1":
          this.eye1= true;
          this.textPass1 = "password";
          break;
        
        case "2":
          this.eye2= true;
          this.textPass2 = "password";
          break;

        case "3":
          this.eye3= true;
          this.textPass3 = "password";
          break;
      }
    },
    entrar() {
      const ventana=this;
      const baseURI = '/auth-server/oauth/token';
      const options = {
        headers: {
            'Authorization':'Basic Zmlyc3RMb2dpbjplbnJvbDEyNA=='
        }
      };
      const params = new URLSearchParams();
      params.append('username', this.cif);
      params.append('password', this.token);
      params.append('grant_type', 'password');
      let loader = this.$loading.show();
      //llamamos al servicio de validacion de token
      this.$http.post(baseURI, params ,options)
      .then((result) => {
        this.$http.defaults.headers.common['Authorization'] = 'Bearer '+result.data.access_token;
        this.$cookies.set('RT',result.data.refresh_token);
        this.mensajeError= null;
        this.confirmacion=null;
        this.tokenValido=true; //esto lo pondremos en el 200 success, y es lo que nos concede acceso a modificar nuestra contrasenia
        this.consultaPerfiles(); //necesario para obtener el header X-USER-PROFILE-ID
        window.scroll({
                    top: 250,
                    left: 0,
                    behavior: 'smooth'
                  });
      })
      .catch(function (error) {
        if(error.response){ 
                if(error.response.status == 400) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    ventana.datosFirma = error.response.data.result.errors[0].info;
                    ventana.beforeSubmit = false;
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                    ventana.confirmacion='KO';
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }else{
                  if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                    ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                  }else{
                    if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                      ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                    }else{ //si no, por defecto
                      ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                    }
                  }
                  ventana.confirmacion='KO';
                  ventana.$http.defaults.headers.common['Authorization'] = null;
                  window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
                }
        }
      })
      .then(function () {
        loader.hide();
      });
    },
      callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.submitted=false;
        this.mensajeError = mensaje;
        if(confirmacion == "OK") {
          this.datosOTP = null;
          this.beforeOTP = false;
          window.scroll({
              top: 0,
              left: 0,
              behavior: 'smooth'
          });
        } else {
          window.scroll({
              top: 470,
              left: 0,
              behavior: 'smooth'
          });
          if(codError == '392H') {
            this.datosOTP = null;
            this.beforeSubmit = true;
          } else if (codError == '089H') {
            this.datosOTP = null;
            this.beforeOTP = false;
            this.mensajeError = 'Usuario bloqueado';
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          }
        }
       /* setTimeout(() => {
          window.location.href = "https://bedemo-eurocaja.ceca.es/3081/3081/#/beext/identificacion";
        }, 5000);*/

       
      },
     callBackCancelarOTP(){
         this.beforeSubmit = true;
         this.submitted=false;
         this.datosOTP = null;
      },
      consultaPerfiles(){
        var ventana=this;
        const baseURI = '/api-users/users/me/profiles';
        let loader = this.$loading.show();
        this.$http.get(baseURI)
        .then((result) => {
          this.$http.defaults.headers.common['X-USER-PROFILE-ID'] = result.data.data[0].id;
        })
        .catch(function (error) {
          if(error.response){
                  if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                    ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                  }else{ //si no, por defecto
                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                  }
                }else{ //si no, por defecto
                  ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                }
                ventana.confirmacion='KO';
                window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
        })
        .then(function () {
          loader.hide();
        });
      },
    changePass(){
      this.submitted = true;
      this.$v.$touch();
          if(this.$v.$invalid) {
            return false;
          }else {
            const ventana=this;
            const baseURI = '/api-users/users/me/firstPassword';
            this.llamada = {
              urlEndpoint : baseURI,
              metodo : 'PUT'
            };
            this.params = {
              currentPassword : this.model.actualPass,
              newPassword: this.model.newPass
            };
            let loader = this.$loading.show();
            this.$http.put(baseURI, this.params)
            .then(() => {
              this.confirmacion='OK';
              /*setTimeout(() => {
                window.location.href = "https://bedemo-eurocaja.ceca.es/3081/3081/#/beext/identificacion";
              }, 5000);*/
              /*this.$router.push({ name:'login', 
                params: { 
                  confirmacion:'OK' //indicador de que el cambio de pass se ha realizado con exito
                }
              });*/
               window.scroll({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                  });
            })
            .catch(error => {
              if(error.response){
                 if(error.response.status == 400) {
                        if(error.response.data.result.errors[0].errorCode == "096H") {
                          if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                            ventana.datosOTP = error.response.data.result.errors[0].info;
                            window.scroll({
                              top: 520,
                              left: 0,
                              behavior: 'smooth'
                            });
                          }
                          ventana.beforeSubmit = false;
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                          ventana.confirmacion='KO';
                          window.scroll({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                          });
                        }
                      }else{
                        if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                          ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                        }else{
                          if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                            ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                          }else{ //si no, por defecto
                            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                          }
                        }
                        ventana.confirmacion='KO';
                        window.scroll({
                          top: 0,
                          left: 0,
                          behavior: 'smooth'
                        });
                      }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
              }
            })
            .then(function () {
              loader.hide();
            });
          }
    }
  }
}
</script>